module.exports = __webpack_public_path__ + "img/logo-sm-dark.cf779a59.png";